<template>
  <div class="ui page inverted dimmer"
       :class="{ active: isLoading }">
    <div class="ui text loader">Loading...</div>
  </div>

  <div id="api-error-msg"
       class="ui negative tiny red message">
    <i class="close icon"
       @click="hideError"></i>
    <div class="centered header">
      <span v-html="strAPIError"></span>
      <span v-show="numOfErrors > 1">
        ({{ numOfErrors }})
      </span>
    </div>
  </div>

  <div id="site-notice-label">
    <div class="ui orange label gts-btn"
         :data-html="loginAdvisoryMessage"
         data-position="bottom center">
      <i class="exclamation triangle icon"></i>
      Scheduled Maintenance
    </div>
  </div>

  <main-header v-if="showHeader"></main-header>

  <!-- <navigation-bar v-show="showNavBar"></navigation-bar> -->

  <router-view></router-view>

  <div class="ui centered basic tiny modal"
       id="session-timeout-modal">
    <div class="ui icon header">
      <i class="clock outline icon"></i>
      Are you still there?
    </div>
    <div class="content">
      <p>
        For security reasons, your connection times out after you've been inactive for a while.</p>
      <p>Click
        <strong>Continue</strong> to stay signed in.
      </p>
      <div class="ui hidden divider"></div>
      <div class="ui yellow inverted tiny progress">
        <div class="bar"></div>
      </div>
    </div>
    <div class="centered actions">
      <button type="submit"
              class="ui right labeled icon primary ok button">
        <i class="right arrow icon"></i>
        Continue
      </button>
    </div>
  </div>

  <div id="app-version">v{{ appVersion }}</div>
  <div id="db-app-version"
       v-if="latestReleasedVersion && appVersion != latestReleasedVersion">DB:
    v{{ latestReleasedVersion }}
  </div>

  <div id="page-advisory-message"></div>

  <div v-if="isAuthenticated && debugMode"
       class="ui red mini label"
       id="debug-label">
    <i class="bug icon"></i>
    DEBUG
    <div class="detail">
      {{ debugTokenSessInfo }}
    </div>
  </div>
</template>

<script>
import MainHeader from '@/components/MainHeader.vue'

import { createNamespacedHelpers } from 'vuex'
const { mapState, mapGetters } = createNamespacedHelpers('user')

import { EXIT_SITE } from '@/store/action-types'

const __DEBUG_TOKEN_EXP_MSECS = 60000 // 1min
const __DEBUG_SESS_EXP_MSECS = 30000 // .5min

const TOKEN_RENEWAL_PADDING = 10000 // 10s Padding - calls extendToken "EXPIRATION" - 10s

export default {
  data() {
    return {
      isLoading: false,
      APIErrorTimeout: null,
      currentView: { name: '', icon: '' },
      strAPIError: '',
      numOfErrors: 0,
      appVersion: __APP_VERSION,
    }
  },
  components: {
    MainHeader,
  },
  computed: {
    ...mapState(['isAuthenticated']),
    ...mapGetters([
      'currentUser',
      'clearingParticipants',
      'currentUserHighestRoleAcrossDTCC',
      'tasks',
      'getTokenExpirationMsecs',
      'getSessionExpirationMsecs',
      'latestReleasedVersion',
      'loginAdvisoryMessage',
      'pageSpecificMessages',
    ]),
    showNavBar() {
      return this.$route.path !== '/'
    },
    showHeader() {
      return (
        this.isAuthenticated &&
        !this.$route.path.includes('/error') &&
        !this.$route.path.includes('/site-maintenance') &&
        !this.$route.fullPath.includes('p=1')
      )
    },
    debugMode() {
      // Combines the build env and an overwrite flag - to enable it comment out the '&& false' part
      return process.env.NODE_ENV === 'development' && false
    },
    debugTokenSessInfo() {
      return `Token: ${this.debugMode ? __DEBUG_TOKEN_EXP_MSECS : this.getTokenExpirationMsecs
        }msecs | Session: ${this.debugMode ? __DEBUG_SESS_EXP_MSECS : this.getSessionExpirationMsecs
        }msecs`
    },
  },
  watch: {
    // Monitor the main "user.js" isAuthenticated flag for changes
    // in order to begin the timers
    isAuthenticated(authenticated) {
      if (authenticated && authenticated === true) {
        this.startClientSessionTimer()
        this.startTokenAutoRenewalTimer()
      } else {
        clearInterval(window.timeoutProgressInterval)
      }
    },
  },
  methods: {
    init(customView) {
      this.setCurrentView(customView)
    },
    setCurrentView(customView) {
      let _allTasks = []
      for (const set in this.tasks) {
        if (Object.hasOwnProperty.call(this.tasks, set)) {
          _allTasks = _allTasks.concat(this.tasks[set])
        }
      }

      this.showCurrentPathAdvisoryMessages()

      this.currentView =
        customView ||
        _allTasks.find((el) => this.$route.path.indexOf(el.route) >= 0)

      document.title = `${import.meta.env.VITE_APP_TITLE} - ${this.currentView ? this.currentView.label : 'Home'
        }`
    },
    showError(jqXHR) {
      let vm = this

      // Allows to show text-based UI error or XHR API error
      vm.strAPIError =
        typeof jqXHR !== 'object'
          ? jqXHR
          : vm.$utils.getAPIErrorMessageHTML(jqXHR)

      vm.numOfErrors = vm.numOfErrors === 0 ? 1 : vm.numOfErrors

      if (!$('.negative.message').transition('is visible')) {
        $('.negative.message').transition('fly down')
        vm.numOfErrors = 0

        // // No auto-hide for Internal Server Errors
        // if (jqXHR.status === 500) return

        // vm.APIErrorTimeout = setTimeout(() => {
        // 	vm.hideError()
        // }, vm.$utils.FORM_SAVED_TIMEOUT)
      } else {
        vm.numOfErrors++
      }
    },
    hideError() {
      let vm = this

      if (!$('.negative.message').transition('is visible')) return

      $('.negative.message').transition('hide')
      vm.strAPIError = ''
      clearTimeout(vm.APIErrorTimeout)

      // $('.negative.message').transition({
      //   animation: 'fly down',
      //   onComplete: function() {
      //     vm.strAPIError = ''
      //     clearTimeout(vm.APIErrorTimeout)
      //   }
      // })
    },
    signOutCurrentUser(event, redirectURL) {
      this.isLoading = true
      this.$store.dispatch(`user/${EXIT_SITE}`, redirectURL)
    },
    startClientSessionTimer() {
      let vm = this
      const TIME_TO_RESPOND_SECS = 60
      if (vm.getSessionExpirationMsecs) {
        $(document).idle({
          onIdle: function () {
            $('#session-timeout-modal')
              .modal({
                blurring: true,
                closable: false,
                onShow() {
                  let $progress = $('#session-timeout-modal .ui.progress')
                  $progress.progress({
                    total: TIME_TO_RESPOND_SECS,
                    value: TIME_TO_RESPOND_SECS - 1,
                    showActivity: false,
                    autoSuccess: false,
                    onChange(percent, value) {
                      // 60 seconds expired. Force Logout.
                      if (value && value[0] === 0) {
                        clearInterval(window.timeoutProgressInterval)
                        $('#session-timeout-modal').modal('hide')
                        // Due to this function being used as an event handler
                        // for the Sign Out link, the 1st param is event object
                        // injected by vuejs
                        vm.signOutCurrentUser(null, '/error/session-expired')
                      }
                    },
                  })
                },
                onVisible() {
                  let $progress = $('#session-timeout-modal .ui.progress')
                  clearInterval(window.timeoutProgressInterval)
                  window.timeoutProgressInterval = setInterval(function () {
                    $progress.progress('decrement')
                  }, 1000)
                },
                onApprove() {
                  vm.extendToken()
                  clearInterval(window.timeoutProgressInterval)
                  $('#session-timeout-modal').modal('hide')
                },
              })
              .modal('show')
          },
          idle: vm.debugMode
            ? __DEBUG_SESS_EXP_MSECS
            : vm.getSessionExpirationMsecs,
        })
      }
    },
    startTokenAutoRenewalTimer() {
      let vm = this

      if (vm.getTokenExpirationMsecs) {
        // On APP LOADING / HARD REFRESH call to extend token so it syncs with the Interval below
        vm.extendToken(false)

        // Start an internval to request new token every 'TokenExpirationMsecs'
        window.tokenAutoRenewInterval = setInterval(
          vm.extendToken,
          vm.debugMode
            ? __DEBUG_TOKEN_EXP_MSECS - TOKEN_RENEWAL_PADDING
            : vm.getTokenExpirationMsecs - TOKEN_RENEWAL_PADDING,
        )
      }
    },
    extendToken(async = true) {
      // Call Extend if and only if we still have a cookie with XSRF token in it, otherwise ignore
      if (this.$utils.getXSRFTokenFromCookie()) {
        $.ajax({
          url: `${AUTH_URL}/token/extend`,
          method: 'PUT',
          async: async,
        })
      }
    },
    showCurrentPathAdvisoryMessages(forceShow) {
      let vm = this
      // Data about messages is not here yet
      if (!vm.pageSpecificMessages) return null

      // go thru all message per page and find the one that currently we are on
      for (const pmsgs in vm.pageSpecificMessages) {
        if (!Object.hasOwnProperty.call(vm.pageSpecificMessages, pmsgs))
          continue

        // don't create new ones
        if ($('#page-advisory-message').toast('get toasts').length > 0) {
          return
        }

        const KEY_ADV_MSG_DISMISSED = `${pmsgs}_advmsgdism_${__ENV}_v${__APP_VERSION}`
        let _sessionStoragePageName = window.localStorage.getItem(
          KEY_ADV_MSG_DISMISSED,
          pmsgs,
        )

        if (vm.$route.name.startsWith(pmsgs) || forceShow) {
          if (_sessionStoragePageName?.startsWith(pmsgs) && !forceShow) continue

          let _aryOfMsgsPerPage = this.pageSpecificMessages[pmsgs]

          _aryOfMsgsPerPage.forEach((item) => {
            // BUILD and SHOW Toast for each msg per page
            $('#page-advisory-message').toast({
              showProgress: 'bottom',
              // position: 'top center',
              showIcon: 'bell',
              // compact: false,
              // closeIcon: true,
              class: item.messageType,
              className: {
                toast: `ui tiny icon message`,
              },
              displayTime: 15000,
              transition: {
                showMethod: 'fly left in',
                showDuration: 800,
                hideMethod: 'fly left in',
                hideDuration: 200,
                closeEasing: 'easeOutCubic',
              },
              title: item.messageHeader,
              message: item.messageBody + item.messageBodyReadOnlyFooter,
              preserveHTML: true,
              onClick() {
                window.localStorage.setItem(KEY_ADV_MSG_DISMISSED, pmsgs)
              },
            })
          })
        }
      }
    },
  },
  // TODO - provide other props and remove all $root references
  provide() {
    return {
      showError: this.showError,
      hideError: this.hideError,
    }
  },
  mounted() {
    // TEST
    // setTimeout(() => {
    //   $('#site-notice-label').transition('scale')
    //   this.$nextTick(() => {
    //     $('#site-notice-label > div').popup()
    //   })
    // }, 800)

    $('body').addClass('esp')

    if (__ENV !== 'PRODUCTION') {
      // eslint-disable-next-line no-console
      console.log('Environment Variables:', import.meta.env)
    }
  },
}
</script>


<style lang="stylus">
[v-cloak] {
  display: none;
}

// Temp hack introduced by 2.9.3 Fomantic https://github.com/fomantic/Fomantic-UI/issues/3002
body .ui {
  /* Override scrollbar-color */
  scrollbar-color: auto !important; /* Use browser default colors */
  /* Override scrollbar-width */
  scrollbar-width: auto !important; /* Use browser default width */
}

.esp {
  background-image: url('./assets/images/ESP/esp-globe-purple-translucent.png') !important;
  background-repeat: no-repeat !important;
  background-position: bottom -120px right -40px !important;
  background-size: 25% !important;
  background: $dark-white;
  background-attachment: fixed;
}

::selection {
  background-color: $highlight-color !important;
}

.ui.card,
.ui.steps .step:not(.active) {
  background: transparentify(#fff, 0.95) !important;
}

.ui.secondary.segment {
  background: transparentify(#f3f4f5, 0.95) !important;
}

.clear {
  clear: both;
}

.crop {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

form label {
  cursor: pointer;
}

div[id*='-view-root'] {
  min-height: calc(100vh - 64px); // $header-height doesn't work in calc()
  position: relative;
  padding-top: 1rem !important;
}

#app {
  height: inherit;
}

#api-error-msg {
  opacity: 0.7;
  display: none;
  position: fixed;
  top: 0;
  left: 50%;
  margin-left: -25rem;
  width: 50rem;
  z-index: 10000;
  word-break: break-all;
  padding-right: 2rem;

  > .close.icon {
    top: 1rem;
    right: 0.8rem;
  }
}

/* x icon in dropdown in semantic seems off as of their v2.8.5 TODO */
.dropdown > .remove.icon {
  top: auto !important;
}

/* style for all button elements, elements with gts-btn class,
  or div.button (e.g. semantic modals)
*/
.gts-btn,
button,
div.button {
  click-down();
  vendor('user-select', none);
  cursor: pointer;
}

.bold-text {
  font-weight: bold;
}

.ui.modal:not(.basic) {
  > .header {
    background-color: $gts-lightgray !important;
    text-shadow();
    text-transform: uppercase;
    font-size: 1rem !important;

    h3 {
      font-size: 1.45rem;
      text-align: center;
    }
  }

  .actions > .button {
    margin-left: 0 !important;
  }
}

.ui.modal {
  .actions {
    padding: 0.75rem 1rem;
  }
}

.dx-data-row.dx-state-hover > td {
  background-color: $gts-lightgray !important;
}

.ui.selection.dropdown {
  & > .icon {
    opacity: 0.5 !important;
  }

  &.active {
    & >.icon {
      opacity: 0.8 !important;
    }
  }

  > .text {
    left: 0;
    bottom: -1px;
  }
}

#debug-label {
  position: fixed;
  z-index: 999999 !important;
  right: 5rem;
  bottom: 1rem;
  opacity: 0.5;

  &:hover {
    opacity: 1;
  }
}

#app-version,
#db-app-version {
  position: absolute;
  color: $dark-white;
  bottom: 0;
  font-size: 8px;
}

#app-version {
  left: 8px;
}

#db-app-version {
  left: 48px;
}

.dirty {
  background: $dirty-field !important;
}

/* overwriting semantic-ui error message look and feel */
.ui.form .ui.error.message {
  margin: 0 !important;
  padding: 0.25rem 0 !important;
  box-shadow: none !important;
  background: none;
  font-weight: 300 !important;
}

/* shake animation */
@keyframes shakeError {
  0% {
    transform: translateX(0);
  }

  15% {
    transform: translateX(0.375rem);
  }

  30% {
    transform: translateX(-0.375rem);
  }

  45% {
    transform: translateX(0.375rem);
  }

  60% {
    transform: translateX(-0.375rem);
  }

  75% {
    transform: translateX(0.375rem);
  }

  90% {
    transform: translateX(-0.375rem);
  }

  100% {
    transform: translateX(0);
  }
}

.ui.form .field.error {
  // animation-name: shakeError;
  // animation-duration: 0.6s;
  // animation-timing-function: ease-in-out;
  position: relative;

  .input-error--message {
    display: block;
    color: $red;
    animation-name: shakeError;
    animation-duration: 0.6s;
    animation-timing-function: ease-in-out;
  }
}

.input-error--message {
  display: none;
  color: $red;
  position: absolute;
  font-size: 0.7rem;
  left: 0;
  bottom: -1.25rem;
  white-space: nowrap;
}

.med-text {
  text-transform: initial !important;
  font-size: 0.9rem !important;
  color: $gts-text-color !important;
}

.small-text {
  text-transform: initial !important;
  font-size: 0.75rem !important;
  color: $gts-text-color !important;
}

.inverted .small-text, 
.small-text.inverted {
  color: $lightgray-color;
}

.centered {
  text-align: center !important;
}

.floated-left {
  float: left;
}

.floated-right {
  float: right;
}

.gts-subview-header {
  font-size: 1.5rem !important;
  text-transform: uppercase !important;
  margin-top: -0.14285714em !important;

  > .sub.header {
    text-transform: none !important;
  }

  > .floated-right.ui.label {
    /* vertical alignment - TODO */
    margin-top: 0.25rem !important;
  }
}

.all-caps {
  text-transform: uppercase !important;
}

input.all-caps::placeholder {
  text-transform: none;
}

.header-cell {
  background-color: $gts-lightgray;
  font-weight: bold;
}

.header-cell--wrap {
  white-space: normal !important;
}

.header-cell--nowrap {
  white-space: nowrap;
}

.display-none {
  display: none !important;
}

.display-inline-block {
  display: inline-block;
}

.hidden-visibly {
  visibility: hidden;
}

.abs-center {
  display: flex; // make us of Flexbox
  align-items: center; // does vertically center the desired content
  justify-content: center; // horizontally centers single line items
  text-align: center; // optional, but helps horizontally center text that breaks into multiple lines
}

#site-notice-label {
  display: none;
  position: absolute;
  top: 1.35rem;
  width: 100%;
  text-align: center;
  z-index: 999;
}

.no-padding {
  padding: 0 !important;
}

.no-margin {
  margin: 0 !important;
}

.break-word {
  word-break: break-word;
  word-wrap: break-word;
}

.with-hover-text {
  cursor: help !important;
}

.cursor.pointer {
  cursor: pointer;
}

.overflown {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
